
import { Trash2 } from "lucide-react";
import {UserInfoSchema} from "./UserSchema";


export function UserItem({item,  onClick, onDelete }: { item: UserInfoSchema, onClick: (id: string) => void, onDelete: (id: string) => void}) {


return (
  
  
    <tr key={item.userId} className="border-t hover:bg-gray-100 cursor-pointer dark:bg-zinc-700 dark:hover:bg-zinc-600" onClick={() => onClick(item.userId as string)}>
      
      <td className="px-4 py-2">
         {item.error ? (
          <div>
          <div>{item.userName}</div>
          <div className="name text-wrap truncate text-red-600 font-bold">{item.error}</div>
          </div>
        ):item.userName}
        </td>
      <td className="px-4 py-2">{item.isAdmin?"Administrator":"User"}</td>
      <td className="px-4 py-2">{item.company}</td>
      <td className="px-4 py-2">
        <input
          type="checkbox"
          checked={item.isActive}
          readOnly
          className="accent-sky-600 dark:accent-orange-400 w-4 h-4"
        />
      </td>
      <td className="px-4 py-2">
        <button
          
          onClick={(e) => {e.stopPropagation();  onDelete(item.userId as string)}}
          className="accent-sky-600 dark:accent-orange-400 w-4 h-4"
        ><Trash2 /></button>
      </td>
    </tr>
    
)
  
}